import { cardBaseProps as s } from "./highrise1078.mjs";
import { dialogProps as o } from "./highrise1180.mjs";
import { keysOf as r } from "./highrise1054.mjs";
const e = Object.assign(Object.assign({}, s), o), m = r(e);
export {
  e as presetProps,
  m as presetPropsKeys
};
